import React from 'react';
// import '../../styles/accueil/CGV.css';
import '../../styles/accueil/GCV.css'

function CGV() {
  return (
    <div className="cgv-container">
      <h1>CONDITIONS GÉNÉRALES DE VENTE (CGV)</h1>
      <h2>Pour les acheteurs</h2>

      <ol>
        <li><strong>Présentation de la plateforme</strong><br/>
          La plateforme Tsenan’ny Tantsaha est un site de mise en relation entre les producteurs agricoles (tantsaha) et les acheteurs à Madagascar.
          Elle permet aux tantsaha de publier et vendre directement leurs produits. La plateforme gère l’affichage, la commande, le paiement et la livraison.
        </li>

        <li><strong>Acceptation des CGV</strong><br/>
          Toute commande sur le site implique l’acceptation sans réserve des présentes Conditions Générales de Vente.
          Les CGV peuvent être modifiées à tout moment. Les conditions applicables sont celles en vigueur au moment de la commande.
        </li>

        <li><strong>Produits proposés</strong><br/>
          Les produits sont d’origine agricole (frais ou transformés).<br/>
          Les descriptions, photos et prix sont fournis par les producteurs.<br/>
          La plateforme vérifie les annonces mais ne garantit pas la disponibilité permanente de chaque produit.
        </li>

        <li><strong>Commande</strong><br/>
          L’acheteur choisit ses produits sur le site et valide la commande.<br/>
          Il fournit les informations nécessaires pour la livraison.<br/>
          Un récapitulatif de commande est présenté avant validation finale.
        </li>

        <li><strong>Prix et paiement</strong><br/>
          Les prix affichés concernent uniquement les produits.<br/>
          Les frais de livraison sont ajoutés selon la zone de livraison.<br/>
          Le paiement se fait en ligne via MVola, Orange Money, ou tout autre moyen sécurisé proposé.<br/>
          Le paiement est sécurisé et géré par la plateforme.
        </li>

        <li><strong>Livraison</strong><br/>
          La livraison est organisée par la plateforme ou ses partenaires.<br/>
          Délai indicatif : 1 à 5 jours ouvrés, selon la région.<br/>
          L’acheteur doit être disponible et joignable au moment de la livraison.<br/>
          Les frais de livraison sont indiqués clairement avant validation.
        </li>

        <li><strong>Réception et réclamation</strong><br/>
          L’acheteur doit vérifier les produits à la réception.<br/>
          En cas de produit manquant, abîmé ou non conforme, une réclamation doit être faite le jour même via le site ou par téléphone.<br/>
          Passé ce délai, aucune réclamation ne sera acceptée.
        </li>

        <li><strong>Droit de rétractation</strong><br/>
          En raison de la nature périssable des produits, le droit de rétractation ne s’applique pas (conformément à la loi malgache et au Code de la consommation).<br/>
          Aucun retour ne sera accepté sauf entente préalable en cas de défaut grave.
        </li>

        <li><strong>Données personnelles</strong><br/>
          Les informations collectées sont utilisées uniquement pour le traitement de la commande.<br/>
          Elles ne sont ni revendues, ni partagées à des tiers non autorisés.
        </li>

        <li><strong>Responsabilités</strong><br/>
          La plateforme n’est pas responsable des erreurs d’adresse ou d’absence du client à la livraison.<br/>
          En cas de litige sur un produit, une médiation est possible entre le vendeur et l’acheteur via la plateforme.
        </li>

        <li><strong>Droit applicable</strong><br/>
          Les présentes CGV sont régies par le droit malgache.<br/>
          Tout litige non résolu à l’amiable pourra être porté devant les juridictions compétentes.
        </li>
      </ol>

      <p className="cgv-footer">
        Dernière mise à jour : ___ / ___ / 202_<br/>
        Plateforme Tsenan’ny Tantsaha<br/>
        Contact : contact@tsenannytantsaha.mg | 03x xx xxx xx
      </p>

      <h2>🌾 FEPETRA FIVIDIANANA (CGV) – Malagasy simplifiée</h2>

      <ol>
        <li><strong>Mombamomba ny sehatra</strong><br/>
          Ny Tsenan’ny Tantsaha dia sehatra hanampy ny tantsaha hivarotra mivantana amin’ny mpividy, amin’ny alalan’ny internet.
        </li>

        <li><strong>Fankatoavana</strong><br/>
          Rehefa mividy ianao dia manaiky ireo fepetra rehetra eto.<br/>
          Ny fepetra dia mety havaozina arakaraka ny fotoana.
        </li>

        <li><strong>Momba ny entana</strong><br/>
          Ny entana amidy dia vokatra ara-pambolena.<br/>
          Ny sary sy ny vidiny dia avy amin’ny tantsaha.<br/>
          Mety ho lany haingana na miova arakaraka ny zava-misy.
        </li>

        <li><strong>Fomba fividianana</strong><br/>
          Mifidy entana → manome adiresy → mandoa vola<br/>
          Alohan’ny fanamafisana, dia miseho amin’ny mpividy ny famintinana ny baikony.
        </li>

        <li><strong>Vidiny sy fandoavana</strong><br/>
          Ny vidiny dia ho an’ny entana ihany.<br/>
          Ny saram-pitaterana dia ampidirina rehefa hametraka kaomandy.<br/>
          Mandoa amin’ny MVola, Orange Money, sns.<br/>
          Ny fandoavana dia azo antoka sy tantanan’ny sehatra.
        </li>

        <li><strong>Fanaterana</strong><br/>
          Aterina amin’ny alalan’ny mpitatitra voatendrin’ny sehatra.<br/>
          1 hatramin’ny 5 andro arakaraka ny toerana.<br/>
          Tokony ho voaray tsara ny mpividy rehefa tonga ny entana.
        </li>

        <li><strong>Fanamarinana sy fitarainana</strong><br/>
          Jerena avy hatrany ny entana rehefa tonga.<br/>
          Raha misy simba na diso, ilazao avy hatrany amin’ny sehatra.<br/>
          Raha tsy misy fitarainana ara-potoana dia heverina fa marina ny fividianana.
        </li>

        <li><strong>Tsy afaka miverina</strong><br/>
          Noho ny maha-vokatra mora lo, tsy azo averina ny entana.<br/>
          Raha tena misy olana goavana, dia azo ifampiresahana.
        </li>

        <li><strong>Mombamomba manokana</strong><br/>
          Ny anaranao sy ny adiresy dia tsy ho zaraina amin’ny olona hafa.<br/>
          Ampiasaina ho amin’ny fanaterana sy fandoavana ihany.
        </li>

        <li><strong>Andraikitra</strong><br/>
          Raha diso adiresy na tsy tratra antso ianao, dia tsy andraikitry ny sehatra izany.<br/>
          Raha misy olana amin’ny kalitaon’ny entana, azo atao ny fifampiraharahana.
        </li>

        <li><strong>Lalàna mihatra</strong><br/>
          Ity fepetra ity dia arahin’ny lalàna eto Madagasikara.<br/>
          Raha misy olana dia hoezahina hovahana am-pilaminana aloha.
        </li>
      </ol>
    </div>
  );
}

export default CGV;
